import * as types from './types';

export const openFiltersBar = () => ({
  type: types.FILTERS_BAR_OPEN
});

export const closeFiltersBar = () => ({
  type: types.FILTERS_BAR_CLOSE
});